/* WhatsApp de Soporte de AdminAI. Lo usan el botón "Necesito ayuda" y el mensaje de WhatsApp desconectado (AF327).
   Es el más actualizado (parametry/support.phone no se usa, L15) */
export const SUPPORT_WSP_NUMBER = '5493413439207';

/* el mismo número, para mostrar */
export const SUPPORT_WSP_DISPLAY = '+54 9 341 343-9207';

export function supportWspLink(text: string = ''): string {
    return 'https://wa.me/' + SUPPORT_WSP_NUMBER + (text ? '?text=' + encodeURIComponent(text) : '');
}
